/**
 * Helper de tracking PWA — dual-tracking (PostHog + MongoDB propio).
 *
 * PostHog se carga via CDN inline en index.html y expone window.posthog.
 * Backend guarda en colecciAn pwa_events para agregacion propia sin
 * depender de la PostHog Query API.
 *
 * Uso:
 *   import { trackPwa } from '../utils/trackPwa';
 *   trackPwa('ios_install_banner_shown', { dismissed_before: false });
 */
import { API_URL } from '../config/api';

const BASE_PROPS = Object.freeze({ device: 'iPhone', browser: 'Safari' });

export const trackPwa = (event, props = {}) => {
  const merged = { ...BASE_PROPS, ...props };

  // 1. PostHog (dashboard externo)
  try {
    if (typeof window !== 'undefined' && window.posthog?.capture) {
      window.posthog.capture(event, merged);
    }
  } catch (e) {
    // silencioso: nunca romper UX por analytics
  }

  // 2. Backend propio (panel del creador)
  try {
    fetch(`${API_URL}/pwa-events/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event, properties: merged }),
      credentials: 'include',
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    // silencioso
  }
};

export default trackPwa;
